import { render } from "./business-owners.vue?vue&type=template&id=00421dba"
import script from "./business-owners.vue?vue&type=script&lang=js"
export * from "./business-owners.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/main/master-business/business/business-owners.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "00421dba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('00421dba', __exports__)) {
    console.log('reload')
    api.reload('00421dba', __exports__)
  }
  
  module.hot.accept("./business-owners.vue?vue&type=template&id=00421dba", () => {
    console.log('re-render')
    api.rerender('00421dba', render)
  })

}


export default __exports__